import { Link, type LinkProps } from "react-router-dom";

type AppLinkProps = Omit<LinkProps, "to"> & {
  href: string;
};

/** Drop-in replacement for next/link — maps `href` to React Router `to`. */
export function AppLink({ href, ...props }: AppLinkProps) {
  return <Link to={href} {...props} />;
}
